import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from "gatsby"

import NavModuleSearchBar from './NavModuleSearchBar'
import NavModuleSearchTags from './NavModuleSearchTags'
import NavModuleSearchApplyButton from './NavModuleSearchApplyButton'
import { useStore } from '../../../../../lib/context'
import { observer } from 'mobx-react-lite'
import {motion} from 'framer-motion'
import NavModuleSearchCloseButton from './NavModuleSearchCloseButton'
import NavModuleSearchClearButton from './NavModuleSearchClearButton'
import NavModuleActiveSearchFilters from './NavModuleActiveSearchFilters'
import NavModuleSEarchTagsCarouselControls from './NavModuleSearchTagsCarouselControls'

const NavModuleSearch =  observer(() => {
    const {articleQueryStore: {isSearching, setTags}, uiStore: {navModule__collapsed}} = useStore()
    
    const data = useStaticQuery(graphql`
        query TagsQuery {
            allContentfulV2Tag(filter: {node_locale: {eq: "en-US"}}, sort: {fields: priority, order: ASC}) {
                edges {
                    node {
                        name
                    }
                }
            }
        }
      
    `);

    


    useEffect(() => {
        const tags = data.allContentfulV2Tag.edges.map((e) => e.node)
        setTags(tags)
    }, [])

    return (
        <div className='elevate'>
            
            {isSearching ? <NavModuleSearchCloseButton/> : navModule__collapsed ? null : <NavModuleSearchBar/>}
            
            
            {isSearching && 
                [
                <motion.div
                    key="nm-s-tags"
                    initial={{ opacity: 0, y: 3}}
                    animate={{ opacity: 1, y: 0}}
                    exit={{ opacity: 0, y: -1}}
                    transition={{delay: .18}}
                >

               
                    <NavModuleSearchTags />
                    <NavModuleSEarchTagsCarouselControls/>
                    <NavModuleActiveSearchFilters/>
                </motion.div>,
                <motion.div
                    key="nm-s-btns"
                    initial={{ opacity: 0, y: 3}}
                    animate={{ opacity: 1, y: 0}}
                    exit={{ opacity: 0, y: -1}}
                    transition={{delay: .25}}
                >

                

                    <div className="grid">
                        <NavModuleSearchClearButton/>
                        <NavModuleSearchApplyButton/>
                    </div>
                </motion.div>,

                ]
            }

            <style jsx>{`
                .grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    grid-gap: 12px;
                }
            `}</style>
        </div>
    )
})

export default NavModuleSearch